import Anchor from './anchor';
export default Anchor;
